    <div class="chat-widget" [ngClass]="{'recipientChatContainer signing-area-activity-tab': (view === 'signingArea' || view === 'senderArea'), 'documentActivitieschatContainer': view === 'documentArea'}">
        @if(activitiesLoader$ | async){
            <app-skeleton [loop]="6" [section]="'activity-tab-signing-sidebar-loader'"></app-skeleton>
        } @else {
            <!-- User Chat messages -->
            <section class="chat-app-window">
                <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="activity-tab" [ngClass]="{'activity-tab-without-chat': view === 'signingArea' && documentDetails$?.allow_chat === 0}">
                    <div class="">
                        <div class="user-chats" [ngClass]="{'user-chats-disable': view === 'signingArea' && documentDetails$?.allow_chat === 0}" #scroll>
                            <div class="chats">
                                <app-activity-log-container [loggedInUser]="userSettings$ | async" [is_sender]="is_sender" [roleDetail]="roleDetail" [roleId]="roleId" [activities]="(activities$ | async)"></app-activity-log-container>
                            </div>
                        </div>
                    </div>
                </ng-scrollbar>                
                <app-activity-form [hasViewAccess]="hasViewAccess" [documentDetails$]="documentDetails$" [roleId]="roleId" [documentId]="document_id" [view]="view"></app-activity-form>
            </section>
        }
    </div>